import React, { FunctionComponent, useRef } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { withScope, captureException } from '@sentry/browser';
import { assign, getUUID } from '~/utils';

interface IUiErrorBoundaryProps {
    children: React.ReactNode;
    fallbackComponent?: FunctionComponent<FallbackProps>;
}

const UiErrorBoundary = ({ children, fallbackComponent = () => null }: IUiErrorBoundaryProps) => {
    const errorTagRef = useRef<string>(getUUID());

    const errorHandler = (error: Error, info: { componentStack: string }) => {
        // sentry 错误上报
        withScope((scope) => {
            scope.setExtra('error', 'error_boundary');
            scope.setExtra('stack', info.componentStack?.split('\n'));
            scope.setTag('uuid', errorTagRef.current);
            captureException(error);
            errorTagRef.current = getUUID();
        });
    };
    return (
        <ErrorBoundary
            FallbackComponent={(props) => {
                return fallbackComponent(assign({ errorTag: errorTagRef.current }, props));
            }}
            onError={errorHandler}
        >
            {children}
        </ErrorBoundary>
    );
};

export default UiErrorBoundary;
